import { Stage } from './types/parameters';

export const IFRAME_ENDPOINTS = {
  local: 'http://localhost:3004',
  test: 'http://localhost:3004', // for automated tests
  dev: 'https://passv2-dev.civic.com',
  preprod: 'https://passv2-preprod.civic.com',
  prod: 'https://passv2.civic.com',
};

export const getCivicPassEndpoint = (stage: Stage): string => {
  const endpoint = IFRAME_ENDPOINTS[stage];
  if (!endpoint) {
    throw new Error(`Invalid stage ${stage}`);
  }
  return endpoint;
};
